import { validate } from 'email-validator';

/**
 * Validates an email address.
 *
 * To know valid/invalid/not-supported emails
 * @see https://github.com/manishsaraan/email-validator/blob/master/test.js
 *
 * @param {string} email - Email address to validate
 * @returns {boolean}
 */
export const validateEmailAddress = (email: string): boolean => validate(email);
